import installationInstructions from './installationInstructions';

const humidifierCategoryContent = {
  installationInstructions
}

export { humidifierCategoryContent };
